var _require = require('prettier/standalone'),
    _require$doc$builders = _require.doc.builders,
    concat = _require$doc$builders.concat,
    group = _require$doc$builders.group,
    indent = _require$doc$builders.indent,
    join = _require$doc$builders.join,
    line = _require$doc$builders.line,
    softline = _require$doc$builders.softline;

var printObject = function printObject(node, path, print, options) {
  return group(concat(['{', indent(concat([options.bracketSpacing ? line : softline, join(concat([',', line]), path.map(print, 'arguments').map(function (arg, index) {
    return concat([node.names[index], ': ', arg]);
  }))])), options.bracketSpacing ? line : softline, '}']));
};

var printParameters = function printParameters(node, path, print) {
  return group(concat([indent(concat([softline, join(concat([',', line]), path.map(print, 'arguments'))])), softline]));
};

var printArguments = function printArguments(node, path, print, options) {
  if (node.names && node.names.length > 0) {
    return printObject(node, path, print, options);
  }

  if (node.arguments && node.arguments.length > 0) {
    return printParameters(node, path, print);
  }

  return '';
};

var FunctionCall = {
  print: function print(_ref) {
    var node = _ref.node,
        path = _ref.path,
        _print = _ref.print,
        options = _ref.options;
    return concat([path.call(_print, 'expression'), '(', printArguments(node, path, _print, options), ')']);
  }
};
module.exports = FunctionCall;